export const isNumber = (value: string) => {
  return /^\d+$/.test(value);
};
